// extracted by mini-css-extract-plugin
export default {"newHeaderWrapper":"_jm9bid","overrideBackground":"_igmd09","apps-count":"_1a1lbg3","appsCount":"_1a1lbg3","mobileHeaderSpacing":"_fmjmdx"};